import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./components/login/login.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { NewPartsComponent } from "./components/new-parts/new-parts.component";
import { PartInfoComponent } from "./components/part-info/part-info.component";
import { SupplyInfoComponent } from "./components/supply-info/supply-info.component";
import { PackageInfoComponent } from "./components/package-info/package-info.component";
import { PartDetailsComponent } from "./components/part-details/part-details.component";
import { GlobalPartInfoComponent } from "./components/global-part-info/global-part-info.component";
import { NewPackageComponent } from "./components/new-package/new-package.component";
import { TodoComponent } from "./components/todo/todo.component";
import { PackageComponent } from "./components/package/package.component";
import { PackageDashboardComponent } from "./components/package-dashboard/package-dashboard.component";
import { PartStatusComponent } from "./components/part-status/part-status.component";
import { formsEditGuardService } from "./services/formsEditGuard";
import { NotificationComponent } from "./components/notification/notification.component";
import { AuthguardGuard } from "./services/authguard.guard";
import { RegistrationComponent } from "./components/registration/registration.component";
// import { KpiComponent } from "./components/kpi/kpi.component";
import { UsermanagementComponent } from "./components/usermanagement/usermanagement.component";
import { UserActivationComponent } from "./components/user-activation/user-activation.component";
import { PackageRevisionComponent } from "./components/package-revision/package-revision.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { ForgotUsernameComponent } from "./components/forgot-username/forgot-username.component";
import { SupplierCodeComponent } from "./components/supplier-code/supplier-code.component";
import { SupplierManagementComponent } from "./components/supplier-management/supplier-management.component";
import { DeliveryPointComponent } from "./components/delivery-point/delivery-point.component";
import { VendorSchedulerComponent } from "./components/vendor-scheduler/vendor-scheduler.component";
import { LineNumberComponent } from "./components/line-number/line-number.component";
import { SupplierDatabaseComponent } from "./components/supplier-database/supplier-database.component";
import { PoLedgerComponent } from "./components/po-ledger/po-ledger.component";
import { PoLedgerTotalComponent } from "./components/po-ledger-total/po-ledger-total.component";
import { PoLedgerSubTotalComponent } from "./components/po-ledger-sub-total/po-ledger-sub-total.component";
import { PoLedgerDailyComponent } from "./components/po-ledger-daily/po-ledger-daily.component";
import { SupplierDatabaseAddressComponent } from "./components/supplier-database-address/supplier-database-address.component";
import { SupplyProcessCodeComponent } from "./components/supply-process-code/supply-process-code.component";
import { L4kpiComponent } from "./components/l4kpi/l4kpi.component";
import { GroupNumberComponent } from "./components/group-number/group-number.component";
import { MoviewSupplierComponent } from "./components/moview-supplier/moview-supplier.component";
import { WeeklyViewComponent } from "./components/weekly-view/weekly-view.component";
import { PoFcdailyComponent } from "./components/po-fcdaily/po-fcdaily.component";
import { MaintainenceComponent } from "./components/maintainence/maintainence.component";
import { KpiNewComponent } from "./components/kpinew/kpinew.component";
import { PoFcmonthlyComponent } from "./components/po-fcmonthly/po-fcmonthly.component";
import { PoFcjunComponent } from "./components/po-fcjun/po-fcjun.component";
import { PoDashboardComponent } from "./components/po-dashboard/po-dashboard.component";
import { RoleGuardService as RoleGuard } from "./services/role-guard.service";
import { PoSummaryComponent } from "./components/po-summary/po-summary.component";
import { PoExportsComponent } from "./components/po-exports/po-exports.component";
import { RestrictAccessComponent } from "./components/restrict-access/restrict-access.component";
import { SpcConfigComponent } from "./components/spc-config/spc-config.component";
import { DownloadComponent } from "./download/download.component";
import { UploadComponent } from "./components/upload/upload.component";
import { PackageuploadComponent } from "./components/packageupload/packageupload.component";
import { KkuploadComponent } from "./components/kkupload/kkupload.component";
import { PartsUploadComponent } from "./components/parts-upload/parts-upload.component";
import { RackUploadComponent } from "./components/rack-upload/rack-upload.component";
import { NoubaUploadComponent } from "./components/nouba-upload/nouba-upload.component";
import { ConfigurationComponent } from "./components/configuration/configuration.component";
import { ServiceproviderComponent } from "./components/serviceprovider/serviceprovider.component";

import { PrefecturesComponent } from "./components/prefectures/prefectures.component";


const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  {
    path: "supplierDatabase",
    component: SupplierDatabaseComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin", "Logistic Admin"]
  },
  {
    path: "L4-kpi",
    component: L4kpiComponent,
    canActivate: [RoleGuard],
    data: ["l4Manager"]
  },
  {
    path: "monthlyviewsupplier",
    component: MoviewSupplierComponent,
    canActivate: [RoleGuard],
    data: ["l4Manager"]
  },
  {
    path: "weeklyviewsupplier",
    component: WeeklyViewComponent,
    canActivate: [RoleGuard],
    data: ["l4Manager"]
  },
  {
    path: "supplieradressDatabase",
    component: SupplierDatabaseAddressComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin", "Logistic Admin"]
  },
  { path: "forgotUsername", component: ForgotUsernameComponent },
  { path: "forgotPassword", component: ForgotPasswordComponent },
  {
    path: "adminSupplierCode",
    component: SupplierCodeComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin", "Logistic Admin"]
  },
  {
    path: "vendorScheduler",
    component: VendorSchedulerComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin"]
  },

  {
    path: "deliveryPoint",
    canActivate: [AuthguardGuard, RoleGuard],
    component: DeliveryPointComponent,
    data: ["Admin", "Logistic Admin"],
    runGuardsAndResolvers: "always"
  },
  {
    path: "supplierManagement",
    canActivate: [AuthguardGuard, RoleGuard],
    component: SupplierManagementComponent,
    data: ["Admin", "SM Admin", "Logistic Admin"]
  },
  { path: "lineNumber", component: LineNumberComponent },
  { path: "downloadData", component: DownloadComponent },
  { path: "uploadData", component: UploadComponent },
  { path: "rackUpload", component: RackUploadComponent },
  { path: "noubaUpload", component: NoubaUploadComponent },

  { path: "packageUpload", component: PackageuploadComponent },
  { path: "kkupload", component: KkuploadComponent },
  { path: "partsUpload", component: PartsUploadComponent },

  {
    path: "resetPassword",
    component: ResetPasswordComponent,
    canDeactivate: [formsEditGuardService]
  },
  {
    path: "um",
    component: UsermanagementComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin", "Logistic Admin"]
  },
  {
    path: "configuration",
    component: ConfigurationComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin"]
  },
  {
    path: "register",
    component: RegistrationComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "SM Admin", "Logistic Admin"]
  },
  { path: "account/:id/:rolename", component: UserActivationComponent },
  // { path: "kpi", canActivate: [AuthguardGuard], component: KpiComponent },
  {
    path: "kpinew",
    component: KpiNewComponent,
    canActivate: [RoleGuard],
    data: ["Logistic", "Operation", "SMQ", "SMVS"]
  },
  {
    path: "notification",
    component: NotificationComponent,
    canActivate: [RoleGuard],
    data: ["Supplier", "Logistic", "Operation", "SMQ", "SMVS"]
  },
  {
    path: "dashboard",
    canActivate: [AuthguardGuard],
    component: DashboardComponent
  },
  {
    path: "newParts",
    component: NewPartsComponent,
    canActivate: [RoleGuard],
    data: ["Supplier", "Logistic", "Operation", "SMQ", "SMVS"]
  },
  {
    path: "partDetails",
    canActivate: [AuthguardGuard],
    component: PartDetailsComponent,
    children: [
      {
        path: "partsInfo/:id",
        canActivate: [AuthguardGuard],
        component: PartInfoComponent,
        canDeactivate: [formsEditGuardService]
      },
      {
        path: "supplyInfo/:id",
        canActivate: [AuthguardGuard],
        component: SupplyInfoComponent,
        canDeactivate: [formsEditGuardService]
      },
      {
        path: "packageInfo/:id",
        canActivate: [AuthguardGuard],
        component: PackageInfoComponent,
        canDeactivate: [formsEditGuardService]
      }
    ]
  },
  {
    path: "packageDashboard",
    component: PackageDashboardComponent,
    canActivate: [AuthguardGuard],
    children: [
      {
        path: "package",
        component: PackageComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: "AdminFusoPackage",
        component: PackageComponent,
        canActivate: [AuthguardGuard],
        data: { adminFuso: true }
      },
      {
        path: "newPackage",
        component: NewPackageComponent,
        canDeactivate: [formsEditGuardService],
        canActivate: [AuthguardGuard]
      },
      {
        path: "newSMPackage",
        component: NewPackageComponent,
        canDeactivate: [formsEditGuardService],
        canActivate: [AuthguardGuard],
        data: { SMcreated: true }
      }
    ]
  },
  {
    path: "supplyInfo",
    component: SupplyInfoComponent,
    canActivate: [AuthguardGuard]
  },
  {
    path: "package",
    component: PackageDashboardComponent,
    canActivate: [AuthguardGuard]
  },
  {
    path: "newPackage",
    component: NewPackageComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Supplier", "Logistic", "Operation", "SMQ", "SMVS"]
  },
  {
    path: "todo",
    component: TodoComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Supplier", "Logistic", "Operation", "SMQ", "SMVS"]
  },
  {
    path: "partStatus",
    component: PartStatusComponent,
    canActivate: [RoleGuard],
    data: [
      "Supplier",
      "Logistic",
      "Operation",
      "SMQ",
      "SMVS",
      "Admin",
      "Reader",
      "Logistic Admin"
    ]
  },
  {
    path: "processCode",
    canActivate: [RoleGuard, AuthguardGuard],
    component: SupplyProcessCodeComponent,
    runGuardsAndResolvers: "always",
    data: ["Assembly Operator"]
  },
  {
    path: "packageRevision",
    component: PackageRevisionComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Supplier", "Logistic", "Operation", "SMQ", "SMVS"]
  },
  {
    path: "poLedger",
    component: PoLedgerComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poTotal",
    component: PoLedgerTotalComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poSubTotal",
    component: PoLedgerSubTotalComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poDaily",
    component: PoLedgerDailyComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  // {
  //   path: "groupNo",
  //   component: GroupNumberComponent,
  //   canActivate: [AuthguardGuard]
  // },
  {
    path: "Maintainence-Activity",
    component: MaintainenceComponent,
    canActivate: [AuthguardGuard]
  },
  {
    path: "poFCDaily",
    component: PoFcdailyComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poFCMonthly",
    component: PoFcmonthlyComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poFCJun",
    component: PoFcjunComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poSummary",
    component: PoSummaryComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "poExports",
    component: PoExportsComponent,
    canActivate: [AuthguardGuard]
  },
  {
    path: "poDashboard",
    component: PoDashboardComponent,
    canActivate: [RoleGuard, AuthguardGuard],
    data: ["Logistic", "LSP"]
  },
  {
    path: "accessDenied",
    component: RestrictAccessComponent,
    canActivate: [AuthguardGuard]
  },
  {
    path: "spcConfig",
    component: SpcConfigComponent,
    canActivate: [RoleGuard],
    data: ["Admin"]
  },
  {
    path: "serPro",
    component: ServiceproviderComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "Logistic Admin"]
  },
  {
    path: "prefectures",
    component: PrefecturesComponent,
    canActivate: [RoleGuard],
    data: ["Admin", "Logistic Admin"]
  },
  {
    path: "**",
    component: PageNotFoundComponent,
    canActivate: [AuthguardGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
